"use client";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { subscribe } from '../utility/utils/broadcast';
import { TOPIC } from '../utility/constants/topicConstants';
import drupalSettingsFunc from '../utility/utils/drupalSettings';
import Storage from '../utility/features/helpers/storageHelper';
import paymentStyles from '../styles/myAccount/payment.module.css';

const Error = ({ errMsg, errTitle, labels, isSavePrefError }) => {
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    if (errMsg) {
      setMessage(errMsg);
      setIsError(true);
    }
  }, [errMsg]);

  useEffect(() => {
    const resettoken_loggedin = JSON.parse(localStorage.getItem('loggedin_resetToken'));
    
    if (Storage.registrationSuccess()) {
      setTimeout(() => Storage.registrationSuccess(null), 500);
      showSuccess(labels.RegisterSuccessMessage);
    } else if (resettoken_loggedin) {
      localStorage.removeItem('loggedin_resetToken');
      setIsError(true);
      setMessage('Invalid request');
    } else {
      subscribe(TOPIC.API.LOADING, hideError);
      subscribe(TOPIC.API.ERROR, errorHandler);
      subscribe(TOPIC.NOTIFY.SUCCESS, showSuccess);
    }
  }, []);

  const errorHandler = (error) => {
    if (!error) {
      const labels = drupalSettingsFunc('someErrorOccoured') || {};
      setIsError(true);
      setMessage(labels.someErrorOccoured || 'Some Error Occured!');
      return;
    }

    if (error.response && error.response.data && error.response.data.errorCode) {
      const errcodereceived = error.response.data.errorCode;
      const errcodeformatted = errcodereceived.replace(/_/g, '');
      const labels = drupalSettingsFunc(errcodeformatted);
      const errMsg = labels[errcodeformatted];
      setIsError(true);
      setMessage(errMsg);
      return;
    }

    if (error.errors && error.errors.length > 0) {
      const errorCode = error.errors[0].code;
      const errcodeformatted = errorCode.replace(/_/g, '');
      const labels = drupalSettingsFunc(errcodeformatted);
      const errMsg = labels[errcodeformatted] || errMsg;
      setIsError(true);
      setMessage(errMsg);
    }

    if (error.response && error.response.config && error.response.config.url && error.response.config.url.endsWith('getsurveyurl')) {
      return;
    }

    setIsError(true);
    setMessage(error.genericMessage);
  };

  const showSuccess = (message) => {
    setIsSuccess(true);
    setMessage(message);
  };

  const hideError = () => {
    setIsError(false);
  };

  return (
    <>
      {isError && <div className='row' id={`${paymentStyles['errorMessage']}`}>
        <div className='container-fluid'>
          <div className={`col-12 text-white ${paymentStyles['bg-dark']} ${paymentStyles['p-12']} m-0 ${paymentStyles['mb-20']}`}>
            <div className='align-items-center row'>
              <div className='col-2 text-center'>
                <img src='/images/MyAccount/Icons/error-notification-icon.png'
                  className='mb-5'
                  alt='Temporarily Locked'
                  width='65'
                />
              </div>
              <div className='col-10'>
                {errTitle && <div className='row'>
                  <div className='col-12'>
                    <span className={`${paymentStyles['tg-ft-20pt']}`}>{errTitle}</span>
                  </div>
                </div>}
                <div className='row'>
                  <div className='col-12'>
                    <span className={`${errTitle ? paymentStyles['tg-ft-15pt'] : paymentStyles['tg-ft-26pt']}`}>{message}</span>
                    <br/>
                    
                    {
                      !isSavePrefError && 
                      <>
                        <input type="button" onClick={() => window.location.reload()}
                            className={`btn btn-lg btn-primary gfw-4 glh-1_2 w-50 mb-10 mt-3 ${paymentStyles['btn-primary']}`}
                            value='Try again' />
                      </>
                    }
                    
                  </div>                      
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>}
      {isSuccess && <div className='row'>
        <div className='container-fluid'>
          <div className='col-12 text-white bg-dark p-12 m-0 mb-20 '>
            <div className='align-items-center row'>
              <div className='col-12 col-md-2 text-center'>
                <img src='/images/MyAccount/Icons/ico-success-notify.png' className='mb-5' alt='Temporarily Locked' width='65' />
              </div>
              <div className='col-12 col-md-10'>
                <div className='row'>
                  <div className='col-12'>
                    <span className='tg-ft-26pt'>{labels.SUCCESS}</span>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-12'>
                    <span className='tg-ft-20pt'>{message}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>}
    </>
  );
};

Error.propTypes = {
  errMsg: PropTypes.string,
  errTitle: PropTypes.string,
  labels: PropTypes.any,
  isSavePrefError: PropTypes.bool
};

export default Error;